import React, { ReactNode } from 'react';
import { Helmet } from 'react-helmet';
import Footer from './footer';
import Navbar from './navbar';
import SEO from './seo';

interface SEO {
    title: string;
    description?: string;
    image?: string;
    other?: ReactNode;
}

export default function Layout({
    children,
    seo,
    showNavbarPlaceholder,
    isHome,
}: {
    children: ReactNode;
    seo: SEO;
    showNavbarPlaceholder?: boolean;
    isHome?: boolean;
}) {
    return (
        <div id="wrapper">
            <Helmet>
                <link rel="preconnect" href="https://fonts.gstatic.com" />
                <link
                    href="https://fonts.googleapis.com/css2?family=Rubik:wght@400;600;800&display=swap"
                    rel="stylesheet"
                />
                <link rel="apple-touch-icon" sizes="57x57" href="/apple-icon-57x57.png" />
                <link rel="apple-touch-icon" sizes="60x60" href="/apple-icon-60x60.png" />
                <link rel="apple-touch-icon" sizes="72x72" href="/apple-icon-72x72.png" />
                <link rel="apple-touch-icon" sizes="76x76" href="/apple-icon-76x76.png" />
                <link rel="apple-touch-icon" sizes="114x114" href="/apple-icon-114x114.png" />
                <link rel="apple-touch-icon" sizes="120x120" href="/apple-icon-120x120.png" />
                <link rel="apple-touch-icon" sizes="144x144" href="/apple-icon-144x144.png" />
                <link rel="apple-touch-icon" sizes="152x152" href="/apple-icon-152x152.png" />
                <link rel="apple-touch-icon" sizes="180x180" href="/apple-icon-180x180.png" />
                <link rel="icon" type="image/png" sizes="192x192"  href="/android-icon-192x192.png" />
                <link rel="icon" type="image/png" sizes="32x32" href="/favicon-32x32.png" />
                <link rel="icon" type="image/png" sizes="96x96" href="/favicon-96x96.png" />
                <link rel="icon" type="image/png" sizes="16x16" href="/favicon-16x16.png" />
                <link rel="manifest" href="/manifest.json" />
                <meta name="msapplication-TileColor" content="#ffffff" />
                <meta name="msapplication-TileImage" content="/ms-icon-144x144.png" />
                <meta name="theme-color" content="#ffffff" />
            </Helmet>
            <SEO {...seo} />
            <Navbar showPlaceholder={showNavbarPlaceholder} isHome={isHome} />
            {children}
            <Footer />
        </div>
    );
}
